import React, { MouseEventHandler, useCallback, useMemo } from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandIconComponent from '../Groups/Expand-icon.component';
import DeviceItemComponent from './Device-item.component';
import { IStoredDevice, IStroredSettings } from '@store/Devices.store';
import { checkboxClickHandler } from '@ui/components/Checkbox/checkbox-click-handler';

interface IProps {
    devices: IStoredDevice[];
    name: string;
    id: string;
    settingsList: IStroredSettings[];
    visible: boolean;
    selectedDevices: string[];
    onGroupClick: MouseEventHandler<HTMLLIElement>;
    onDeviceClick: MouseEventHandler<HTMLElement>;
    onDeviceSelect: checkboxClickHandler;
}

const Component: React.FC<IProps> = ({
    devices,
    name,
    id,
    settingsList,
    visible,
    selectedDevices,
    onGroupClick,
    onDeviceClick,
    onDeviceSelect,
}: IProps) => {
    const getDeviceItem = useCallback(
        (device: IStoredDevice) => {
            const { name, imei } = device;
            const selected = selectedDevices.indexOf(imei) > -1;
            return (
                <DeviceItemComponent
                    name={name}
                    imei={imei}
                    selected={selected}
                    onDeviceClick={onDeviceClick}
                    onDeviceSelect={onDeviceSelect}
                />
            );
        },
        [selectedDevices, onDeviceClick, onDeviceClick],
    );

    const handleGroupClick = useMemo(() => {
        if (devices.length > 0) {
            return onGroupClick;
        } else {
            return () => {};
        }
    }, [devices.length, onGroupClick]);

    const filteredList = useMemo(() => {
        if (devices.length > 0) {
            return devices;
        } else {
            return [];
        }
    }, [devices]);

    const length = filteredList.length;

    const deviceList = useMemo(() => {
        if (devices.length > 0) {
            return filteredList.map(getDeviceItem);
        } else {
            return [];
        }
    }, [devices.length, filteredList, getDeviceItem]);

    const title = `${name} (${length})`;
    if (length !== 0)
        return (
            <>
                <ListItemButton
                    className="groups__item"
                    component="li"
                    id={id}
                    onClick={handleGroupClick}
                >
                    <ListItemText
                        classes={{
                            root: 'groups__text-item',
                            primary: 'groups__text',
                        }}
                        primary={title}
                    />
                    <ExpandIconComponent devices={devices} visible={visible} />
                </ListItemButton>
                <Collapse className="devices__item" component="li" in={visible}>
                    <List className="device__list">{deviceList}</List>
                </Collapse>
            </>
        );
    else return <></>;
};

const GroupItemComponent = React.memo(Component);

export default GroupItemComponent;
